export default "__VITE_ASSET__Bl3qt2P7__"